import { render, staticRenderFns } from "./DeleteWithConfirmation.vue?vue&type=template&id=216495dd&scoped=true&"
import script from "./DeleteWithConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DeleteWithConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteWithConfirmation.vue?vue&type=style&index=0&id=216495dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216495dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
